module.exports = __webpack_public_path__ + "img/10863_L.9e945a5e.png";